import React from "react";
import { FiClock } from "react-icons/fi";
import nodata from "../../../../Utils/assets/img/leads_no_data_found_removebg.png";
import { formatDate, formatToINR } from "../../../../Utils/helpers/commonhelper";
import { COLORS, STATUS_STYLE, OWNER_COLORS, TABLE_RANGES } from "../myDashboardConstants";
import { ownerInitials } from "../utils";
import { SectionCard1 } from "../components/SectionCards";
import { RangeTabs } from "../components/RangeTabs";
import { Avatar } from "../components/Avatar";
import { Badge } from "../components/Badge";

/* ===== from sections/RecentDealsTable.jsx ===== */
export function RecentDealsTable({ data, range, onRangeChange }) {
  return (
    <SectionCard1
      title="Recent Deal"
      subtitle="Latest activity across the pipeline"
      icon={<FiClock size={16} />}
      accent={COLORS.info}
      action={
        <RangeTabs
          value={range}
          onChange={onRangeChange}
          options={TABLE_RANGES}
        />
      }
    >
      <div className="sd-table-wrap">
        <table className="sd-table">
          <thead>
            <tr>
              <th>Deal No</th>
              <th>Owner</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Expected Close</th>
            </tr>
          </thead>
          <tbody>
            {!data?.length ? (
              <tr>
                <td colSpan="5" style={{ padding: 0, border: "none" }}>
                  <div
                    style={{
                      height: 300,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={nodata}
                      alt="No data found"
                      style={{ width: "14rem", maxWidth: "80%" }}
                    />
                  </div>
                </td>
              </tr>
            ) : (
              data.map((d, i) => (
                <tr key={d?.deal_no}>
                  <td>
                    <div className="sd-table-strong">{d?.deal_no}</div>
                    <div className="sd-table-muted" style={{ fontSize: 11 }}>
                      {d?.company_name || "-"}
                    </div>
                  </td>
                  <td>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <Avatar
                        initials={ownerInitials(d?.owner_name)}
                        color="#fff"
                        soft={OWNER_COLORS[i % OWNER_COLORS.length]}
                      />
                      <span>{d?.owner_name}</span>
                    </div>
                  </td>
                  <td>
                    <Badge
                      label={d?.deal_status || "-"}
                      styleMap={STATUS_STYLE}
                    />
                  </td>
                  <td className="sd-table-strong">
                    {formatToINR(d?.total_budget?.toLocaleString()) || "-"}
                  </td>
                  <td className="sd-table-muted">
                    {formatDate(d?.expected_closure_date) || "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </SectionCard1>
  );
}
